export type RecurringFrequency = 'daily' | 'weekly' | 'monthly' | 'yearly';

export interface RecurringTransaction {
  id: string;
  userId: string;
  type: 'income' | 'expense';
  categoryId: string;
  categoryName: string;
  potId?: string | null;
  potName?: string | null;
  amount: number;
  currency: string;
  description: string;
  frequency: RecurringFrequency;
  dayOfMonth: number | null; // 1-31 for monthly
  dayOfWeek: number | null; // 0-6 for weekly (0 = Sunday)
  startDate: string;
  endDate: string | null;
  nextOccurrence: string;
  lastProcessed: string | null;
  isActive: boolean;
  createdAt: string;
  updatedAt: string;
}

export interface RecurringListResponse {
  recurring: RecurringTransaction[];
  total: number;
}

export interface CreateRecurringInput {
  type: 'income' | 'expense';
  categoryId: string;
  potId?: string | null;
  amount: number;
  description: string;
  frequency: RecurringFrequency;
  dayOfMonth?: number | null;
  dayOfWeek?: number | null;
  startDate: string;
  endDate?: string | null;
}

export interface UpdateRecurringInput extends Partial<CreateRecurringInput> {
  isActive?: boolean;
}

export const FREQUENCY_LABELS: Record<RecurringFrequency, string> = {
  daily: 'Diaria',
  weekly: 'Semanal',
  monthly: 'Mensal',
  yearly: 'Anual',
};

export const DAYS_OF_WEEK = [
  { value: 0, label: 'Domingo' },
  { value: 1, label: 'Segunda' },
  { value: 2, label: 'Terca' },
  { value: 3, label: 'Quarta' },
  { value: 4, label: 'Quinta' },
  { value: 5, label: 'Sexta' },
  { value: 6, label: 'Sabado' },
];

export function formatNextOccurrence(dateString: string): string {
  const date = new Date(dateString);
  const now = new Date();
  const diffDays = Math.floor((date.getTime() - now.getTime()) / (1000 * 60 * 60 * 24));

  if (diffDays === 0) return 'Hoje';
  if (diffDays === 1) return 'Amanha';
  if (diffDays < 7) return `Em ${diffDays} dias`;

  return date.toLocaleDateString('pt-BR', {
    day: '2-digit',
    month: 'short',
  });
}
